import { create } from "zustand";
import { devtools } from "zustand/middleware";
/** Store for the patient-channel suggested-actions (generate next steps) feature. */
export var useSuggestedActionsStore = create()(devtools(function (set) {
  return {
    nextSteps: null,
    isGenerating: false,
    selectedNextStep: null,
    setNextSteps: function setNextSteps(nextSteps) {
      return set({
        nextSteps: nextSteps
      }, false, "setNextSteps");
    },
    setGenerating: function setGenerating(isGenerating) {
      return set({
        isGenerating: isGenerating
      }, false, "setGenerating");
    },
    setSelectedNextStep: function setSelectedNextStep(selectedNextStep) {
      return set({
        selectedNextStep: selectedNextStep
      }, false, "setSelectedNextStep");
    },
    reset: function reset() {
      return set({
        nextSteps: null,
        isGenerating: false,
        selectedNextStep: null
      }, false, "reset");
    }
  };
}, {
  name: "SuggestedActionsStore",
  enabled: typeof window !== "undefined" && process.env.NODE_ENV !== "production"
}));